var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5833 7C11.5833 4.74513 9.75487 2.91667 7.5 2.91667C5.24513 2.91667 3.41667 4.74513 3.41667 7C3.41667 9.25487 5.24513 11.0833 7.5 11.0833C9.75487 11.0833 11.5833 9.25487 11.5833 7ZM12.75 7C12.75 9.8992 10.3992 12.25 7.5 12.25C4.6008 12.25 2.25 9.8992 2.25 7C2.25 4.1008 4.6008 1.75 7.5 1.75C10.3992 1.75 12.75 4.1008 12.75 7Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle);
export default __webpack_public_path__ + "static/media/circle.bba2ef9f47ec854d42a590a735c5ec3e.svg";
export { ForwardRef as ReactComponent };